// extracted by mini-css-extract-plugin
export default {"page":"Rr-z","landingBackground":"Sr-z","nonLandingBackground":"Tr-z"};